<template>
  <div class="ctrl-btns" v-if="data.share.length > 0">
    <!-- <a
      :title="$locale('global.delete')"
      v-if="isShowDel"
      @click="ctrlFunc(del)"
    ><i class="el-icon-minus">&nbsp;</i></a> -->
    <a
      :title="$locale('global.delete')"
      @click="reduce_fn('DEL')"
    ><i class="el-icon-minus">&nbsp;</i></a>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  methods: {
    reduce_fn(_op) {
      this.$emit("clickAction", _op);
    }
  },
};
</script>
<style scoped lang="less">
.ctrl-btns {
    margin-right: 10px;
  > a {
    display: inline-block;
    cursor: pointer;
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    border: 1px solid @primary-light-grey;
    border-radius: 3px;
    margin-top: 40px;
    margin-right: 12px;
    line-height: 40px;
    text-align: center;

    i {
      color: @primary-dark-grey;
      font-weight: bold;
    }

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      border-color: @primary-yellow;

      i {
        color: @primary-yellow;
      }
    }
  }
}

.alertMsg-block {
  .ctrl-btns > a {
    margin-top: 0;
  }
}
</style>